import { createContext, useState, useEffect, useCallback, useContext } from 'react';
// @ts-expect-error untyped module
import { OPTIN_VIEW_NEW } from 'ui-addon-opt/constants/UIOptConstants';
// @ts-expect-error untyped module
import { fetchUserOptSettings } from 'ui-addon-opt/api/OptinsAPI';
import { jsx as _jsx } from "react/jsx-runtime";
export const OptinContext = /*#__PURE__*/createContext({
  isOptedIn: undefined,
  setOptinStatusFromView: () => {}
});

/**
 * Fetching the opt status more than once causes a console warning that reads
 * "You are using ui-addon-opt without quick-fetch". Pick one of the following:
 *
 * 1. If your app shows a UIOpt button for this optin, call
 *    setOptinStatusFromView() in its onTargetOptinViewChanged callback.
 *
 * 2. OR Set fetchOnMount to the name of the optin you need to fetch.
 */
export function OptinProvider({
  fetchOnMount,
  children
}) {
  const [isOptedIn, setIsOptedIn] = useState();
  const setOptinStatusFromView = useCallback(view => {
    setIsOptedIn(view === OPTIN_VIEW_NEW);
  }, []);
  useEffect(() => {
    if (!fetchOnMount) {
      return;
    }
    fetchUserOptSettings(fetchOnMount).then(({
      availability: {
        optedIn = false
      } = {}
    }) => setIsOptedIn(optedIn)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(OptinContext.Provider, {
    value: {
      isOptedIn,
      setOptinStatusFromView
    },
    children: children
  });
}
export const OptinConsumer = OptinContext.Consumer;
export const useIsOptedIn = () => {
  const {
    isOptedIn
  } = useContext(OptinContext);
  return isOptedIn;
};
export function wireOptinContext(WrappedComponent) {
  return props => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, useContext(OptinContext)));
}